<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rGXgZS/tc-custom/9780830825370.jpg?1696024998110" alt="This image is the cover for the book A Week In the Life of Ephesus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Week In the Life of Ephesus
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>As the city of Ephesus prepares for a religious festival in honor of the emperor Domitian, a Christian landowner feels increasing pressure from the city's leaders to participate.</strong> Can he perform his civic duties and remain faithful to his Lord? Or has the time come for a costly choice?</p> <p>In this historical novel, biblical scholar David deSilva brings to life such compelling struggles faced by the early Christians. Their insistence on the absolute lordship of their own singular deity brought them into conflict not only with the myriad religious cults of the day, but with all the crushing power of the empire itself. Meticulously researched and supplemented by historical images and explanatory sidebars, <em>A Week in the Life of Ephesus</em> poses anew the timeless question of Christianity and empire. Here is a vividly imaginative portrait of the Roman empire in all its beauty and might—and hanging over it, the looming sky of apocalypse.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David A. deSilva
      </h2>
      
      <p class="authorDescription body article"><p>David A. deSilva (PhD, Emory University) is Trustees' Distinguished Professor of New Testament and Greek at Ashland Theological Seminary in Ashland, Ohio. He is the author of over twenty-five books, including <em>An Introduction to the New Testament</em> and <em>Day of Atonement: A Novel of the Maccabean Revolt</em>. He is also an ordained elder in the Florida Conference of the United Methodist Church.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d093de9c